export default ({ id, duration, name, imageUrl }) => `
		<li 
			class="modal__item modal__item--bottom"
			data-rm-service="${id}"
		>
			<label class="modal__label" for="${id}">
				<div class="modal__wrapper-left">
					<input class="modal__input" type="checkbox" name="engine" id="${id}">
					<div class="modal__input--fake"></div>
				</div>
				<img class="modal__item-svg" loading="eager" src="${imageUrl}">
				<div class="modal__wrapper-right">
					<h4 class="modal__item-header">${name}</h4>
					<span class="modal__item-text">${duration} минут</span>
				</div>
			</label>
		</li>
	`;
